import React, { useState } from "react";
import { arrayOf, string } from "prop-types";

import { cmsPlacementsPropType } from "src/features/content-management-system/constants/cmsPropTypes";

import * as S from "./styled";

export default function HomePageCMSBanner({ cmsPlacements, userSegments }) {
  const [isVisibleBanner, toggleIsVisibleBanner] = useState(true);

  return (
    <>
      {isVisibleBanner && cmsPlacements?.length > 0 && (
        <S.CMSWrapper>
          <S.CMSContainer>
            <S.CMSBanner
              cmsPlacements={cmsPlacements}
              handleSetTarget={hasTarget => toggleIsVisibleBanner(hasTarget)}
              isHiddenSeparator
              location="body"
              userSegments={userSegments}
            />
          </S.CMSContainer>
        </S.CMSWrapper>
      )}
    </>
  );
}

HomePageCMSBanner.propTypes = {
  cmsPlacements: cmsPlacementsPropType,
  userSegments: arrayOf(string).isRequired
};

HomePageCMSBanner.defaultProps = {
  cmsPlacements: []
};
